import { useQuery } from "react-query";
import { getScripts } from "../../../../actions/Utilities/ScriptConfiguration";

export default function useGetScripts() {
  return useQuery("GetScripts", getScripts, {
    refetchOnWindowFocus: false,
    staleTime: Infinity,
  });
}
